var _circle, _path, _path2, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgName = function SvgName(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6.8335,
    r: 6,
    fill: "#2E3744"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99997 7.96566C7.78504 7.96566 9.29201 9.34457 9.29201 10.39C9.29201 11.2779 7.77537 11.4868 5.99997 11.4868C4.2149 11.4868 2.70795 10.9259 2.70795 10.2178C2.70795 9.17242 4.22413 7.96566 5.99997 7.96566ZM5.99997 3.4165C7.20905 3.4165 8.17825 4.32122 8.17825 5.44985C8.17825 6.57848 7.20905 7.4832 5.99997 7.4832C4.79088 7.4832 3.82168 6.57848 3.82168 5.44985C3.82168 4.32122 4.79088 3.4165 5.99997 3.4165Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99997 7.96566C7.78504 7.96566 9.29201 9.34457 9.29201 10.39C9.29201 11.2779 7.77537 11.4868 5.99997 11.4868C4.2149 11.4868 2.70795 10.9259 2.70795 10.2178C2.70795 9.17242 4.22413 7.96566 5.99997 7.96566ZM5.99997 3.4165C7.20905 3.4165 8.17825 4.32122 8.17825 5.44985C8.17825 6.57848 7.20905 7.4832 5.99997 7.4832C4.79088 7.4832 3.82168 6.57848 3.82168 5.44985C3.82168 4.32122 4.79088 3.4165 5.99997 3.4165Z",
    stroke: "#2E3744"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6.8335,
    r: 5.5,
    stroke: "#2E3744"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgName);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "name.4726b886e16049b1f99e0dc9f0b626c4.svg";